
import PGWEB_CONFIG from "../../../gpnote.json"

// AppState.js
import * as mWelcome from `./components/s00-welcome.js`;
import * as mContactUs from `./components/s02-contact.js`;
import * as mNotablePGPSites from `./components/s09-notable-pgp-sites.js`;
import * as mInvite from `./components/s20-invite.js`;
import * as mPubkeySelf from `./components/s30-pubkey_self.js`;
import * as mPubkeyContact from `./components/s31-pubkey_contact.js`;
import * as mPubkeyNotFound from `./components/s32-pubkey_not_found.js`;
import * as uPrivKeyLinkQR from `./components/s33-Privkey_link_device_qr.js`;
import * as uPrivKeyLinkScan from `./components/s34-Privkey_link_device_scan.js`;
import * as mMsgCompose from `./components/s41-msg_compose`;
import * as mMsgSent from `./components/s42-msg_sent`;
import * as mMsgRead from `./components/s52-msg_read.js`;
import * as mListNotifications from `./components/s60-list_notifications.js`;
import * as mListContacts from `./components/s61-list_contacts.js`;
import * as mComparisons from './components/s98-comparison.js';
import * as TermsAndConditionsModule from './components/s99-terms_and_conditions.js'
import * as mKeyDetails from `./components/s910-key_details.js`;
import * as mShare from `./components/s911-share.js`;
import * as mNewPrivKey from `./components/s912-new_priv_key.js`;
import * as mNotification from `./components/s920-notification.js`;
import * as mSelectRCPT from `./components/s940-select_rcpt.js`;
import * as mEndorse from `./components/s950-endorse.js`;


export const WelcomeModule = mWelcome;                    // s00
export const ContactUsModule = mContactUs;                // s02
export const NotablePGPSitesModule = mNotablePGPSites;    // s09

export const InviteModule = mInvite;                      // s20

export const PubkeySelfModule = mPubkeySelf;              // s30
export const PubkeyContactModule = mPubkeyContact;        // s31
export const PubkeyNotFoundModule = mPubkeyNotFound;      // s32
export const PrivKeyLinkQRModule = uPrivKeyLinkQR;        // s33
export const PrivKeyLinkScanModule = uPrivKeyLinkScan;    // s34

export const MsgComposeModule = mMsgCompose;              // s41
export const MsgSentModule = mMsgSent                     // s42
export const MsgReadModule = mMsgRead;                    // s52

export const ListNotificationsModule = mListNotifications;// s60
export const ListContactsModule = mListContacts;          // s61

export const ComparisonsModule = mComparisons;            // S98 

export const KeyDetailsModule = mKeyDetails;              // s910
export const ShareModule = mShare;                        // s911
export const NewPrivKeyModule = mNewPrivKey;              // s912
export const NotificationModule = mNotification;          // s920
export const SelectRCPTModule = mSelectRCPT;              // s940
export const EndorseModule = mEndorse;                    // s950


export const BASEURL = PGWEB_CONFIG;

export var MAX_BODY_SIZE = 0;
var API_ENV = null;

import { pubkey_exists } from './crypt_helper.js';
import { SecureAPIClient } from "./SecureAPIClient.js";
import { toaster, update_username, postData, show_modal } from "./utils.js";
import { get_pub_key } from "./crypt_helper.js";

const DATABASE_VERSION_NUMBER = 1

document.global_last_pubkey_seen = {}

// Select a single element by ID
window.$ = (id) => document.getElementById(id);

window.$e = function $(target_el) {
    return {
        getEl: (name) => target_el.querySelector(`[data-ui="${name}"]`),
        getEls: (name) => target_el.querySelectorAll(`[data-ui="${name}"]`)
    };
}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

export const mod_loader = async (module, args) => {

    // console.trace("mod_loader:", module);
    const target = typeof args?.target === 'string' ? args.target : "#content";

    const container = document.querySelector(target);

    const target_el = target === "#content"
        ? container.querySelector(".html_section")
        : container;

    await module.init(target_el, args) //  { page: "s52-msg_read", args: id };
    if (target_el.classList.contains("collapse")) {
        const container_bc = new bootstrap.Collapse(target_el, { toggle: false });
        container_bc.show()
    }
}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

function map_menu2page(element_name, page_name, url_page) {
    document.querySelector(element_name).addEventListener('click', () => {
        mod_loader(page_name, null);
        var page;
        if (url_page)
            page = './?' + url_page;
        else
            page = "./"
        window.history.pushState({ page_id: 1,  }, '', page);
    })
}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

// Handles notifications when the page is open
navigator.serviceWorker.addEventListener('message', event => {

    if (event.data?.type === 'pushsubscriptionchange') {
        console.warn("TODO: pushsubscriptionchange: renew subscription");
        return;
    }

    if (event.data?.notificationData?.data?.notify_test_success === true) {
        if (event.data.type === 'push') {
            document.querySelector(".notificationStatusDisplay").innerText = "Noification received. Click on it."
            display_received_event();
            return;
        }
        if (event.data?.type === 'notificationclick') {
            document.querySelector(".notificationStatusDisplay").innerText = "Noification success!";
            document.querySelector(".btn_ok_notification_clicked_success").disabled = false;
            document.querySelector(".notificationTriggerBtn").disabled = true;
            return
        }
        console.warn("Unhandled case with notify_test_success as true")
        return;
    }

    if (event.data?.notificationData?.data?.notify_suspect === true) {
        // show_modal("Suspect download", "Somebody with an invalid signature tried to downlod the message");
        console.log("TODO: add red flag to open notifications", event.data);
        display_received_event();
        return;
    }
    if (event.data?.notificationData?.data?.notify_msg_downloaded_by_rcpt === true) {
        display_received_event();
        return;
    }

    console.warn("Recived notification, but cannot handled this case:", event.data)
});

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

class db_dbindex {
    constructor() {

        this.dbPromise = idb.openDB('keyval-store', DATABASE_VERSION_NUMBER, {
            upgrade(db) {
                if (!db.objectStoreNames.contains("PrivateKeyPair")) {
                    db.createObjectStore("PrivateKeyPair");
                }
                if (!db.objectStoreNames.contains("ExtPubkey")) {
                    db.createObjectStore("ExtPubkey");
                }
                if (!db.objectStoreNames.contains("Notifications")) {
                    db.createObjectStore("Notifications");
                }
            },
        });

    }

    async get(table, key) {
        return (await this.dbPromise).get(table, key);
    }
    async set(table, key, val) {
        return (await this.dbPromise).put(table, val, key);
    }
    async del(table, key) {
        return (await this.dbPromise).delete(table, key);
    }
    async clear(table,) {
        return (await this.dbPromise).clear(table);
    }
    async keys(table,) {
        return (await this.dbPromise).getAllKeys(table);
    }
}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

class db_keys {
    constructor(table) {
        this.table = table;
    }
    async get(key) {
        return await db.get(this.table, key);
    }
    async set(key, val) {
        return await db.set(this.table, key, val);
    }
    async del(key) {
        return await db.del(this.table, key);
    }
    async clear() {
        return await db.clear(this.table);
    }
    async keys() {
        return await db.keys(this.table);
    }
}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

const db = new db_dbindex();

export const db_PrivateKeyPair = new db_keys("PrivateKeyPair");
export const db_ExtPub = new db_keys("ExtPubkey");
export const db_Notifications = new db_keys("Notifications");

// Application State Management
export class AppState {

    constructor() {

        this.apiClient = new SecureAPIClient($('navbar_loading_spinner'));

        this.start_page();

    }

    async start_page() {

        display_received_event();

        // Get My pubkey
        const pub_key = await get_pub_key();

        const url = new URL(window.location);

        update_username();

        const id = url.searchParams.get('id');

        const pubk = url.searchParams.get('pubk');

        const suspect = url.searchParams.get('suspect');

        if (url.searchParams.get('notify_test'))
            return mod_loader(ListNotificationsModule);

        if (url.searchParams.get('comparison'))
            return mod_loader(ComparisonsModule);

        if (url.searchParams.get('terms-and-conditions') !== null)
            return mod_loader(TermsAndConditionsModule);

        if (url.searchParams.get('comparison') !== null)
            return mod_loader(ComparisonsModule);

        if (url.searchParams.get('contact_us') !== null)
            return mod_loader(ContactUsModule);

        if (suspect)
            return mod_loader(ListNotificationsModule);

        if (id)
            return mod_loader(MsgReadModule, id);

        if (pubk) {
            const pubk_obj = await postData(BASEURL.api + '/pubkey', { pubk });
            const pubk_armoured = pubk_obj.pgp_pubkey

            if (pubk_armoured == null)
                return mod_loader(PubkeyNotFoundModule)

            if (pubk_armoured == pub_key?.myKeyPairPublicKey)
                return mod_loader(PubkeySelfModule);

            if (await pubkey_exists(pubk_armoured) == false)
                return mod_loader(PubkeyContactModule, pubk_armoured);

            return mod_loader(MsgComposeModule, await get_pub_key(pubk_armoured));

        }

        return mod_loader(WelcomeModule);

    }
    // -----------

    showMessage(message, type = 'error', containerId = 'authMessage') {
        toaster({ title: "POST DATA", body: message });
    }

    // -----------

    async handleLogout() {
        try {
            await this.apiClient.logout();
        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            // this.showUnauthenticatedState();
            this.showMessage('Logged out successfully', 'success');
        }
    }

    // -----------

    showAuthenticatedState() {
        const el = document.querySelector('#nav_introduction .welcome_email');
        el.textContent = this.apiClient.user.email;

    }

}

// -----------------------------------------------------------------------------------
function display_received_event() {

    db_Notifications.keys().then((keys) => {
        keys.forEach(key => {
            db_Notifications.get(key).then(notification => {
                if (notification.was_displayed == true)
                    return
                if (notification.data.notify_msg_downloaded_by_rcpt == true ||
                    notification.data.notify_suspect == true) {
                    const notif = notification.data.client_data
                    console.log("notification.data:", notification.data)
                    return toaster({
                        title: notification.title,
                        body: `${notif?.share_time}, ${notif?.ip}`,
                        onclick_module: mListNotifications,
                        key
                    });
                }
                console.log("Unexpected notification");
                return toaster({
                    title: "Unknown notification type",
                    body: "check console log"
                });
            })
        });
    });
}
// -----------------------------------------------------------------------------------
async function get_max_size_and_env() {

    try {
        const parameters = await postData(BASEURL.api + '/parameters', { AppInit: true });
        MAX_BODY_SIZE = parameters.max;
        API_ENV = parameters.env;
    } catch (e) {
        console.error(e);
        show_modal("ERROR", e.message);
    }
}
// -----------------------------------------------------------------------------------
function ribbon_env() {

    var env_name = "UNKNOWN"
    var color = "red"

    if (location.hostname.startsWith("dev-"))
        env_name = "DEV", color = "white"
    else if (location.hostname.startsWith("test-"))
        env_name = "TEST", color = "orange"
    else
        return

    if (env_name != API_ENV)
        console.warn("WARNING: ENV mismatch with API_ENV")

    $("ribbonNavigationBar").querySelector("span").innerText = env_name
    $("ribbonNavigationBar").querySelector("span").style.color = color

    $("ribbonNavigationBar").style.display = "block";

}

// -----------------------------------------------------------------------------------

const start_appstate = async () => {
    await get_max_size_and_env();
    ribbon_env();

    await mod_loader(NotificationModule, { target: ".main_offcanva_section_notify" });
    await mod_loader(NewPrivKeyModule, { target: ".main_offcanva_section_addkey" });
    await mod_loader(SelectRCPTModule, { target: ".main_offcanva_section_rcpt" });

    map_menu2page(".navbar_pubkey_self", PubkeySelfModule);
    map_menu2page(".navbar_link_device_qr", PrivKeyLinkQRModule);
    map_menu2page(".navbar_list_contacts", ListContactsModule);
    map_menu2page(".msg_compose", MsgComposeModule);
    map_menu2page(".notable_pgp_sites", NotablePGPSitesModule);
    map_menu2page(".list_notifications", ListNotificationsModule);
    map_menu2page(".share_connect", InviteModule);
    map_menu2page(".contact_us", ContactUsModule, "contact_us");

    document.querySelector('.background-image-section').classList.add('is-loaded');
    $e(document).getEl("init_bundle_panel").innerHTML = "";

    new AppState();

}
// -----------------------------------------------------------------------------------

start_appstate();
